import { render, staticRenderFns } from "./EditCompetence.vue?vue&type=template&id=1d493de0&"
import script from "./EditCompetence.vue?vue&type=script&lang=ts&"
export * from "./EditCompetence.vue?vue&type=script&lang=ts&"
import style0 from "./EditCompetence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports